import { SearchOptionLinksObject, SearchApi } from 'components/SA/SearchProvider/types'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { getIsInitialLoadReady } from 'selectors/user/isInitialLoadReady'

type UseSearchAutocompleteParams = {
  searchService: SearchApi
  maxSuggestions?: number
}

const useSearchAutocomplete = ({ searchService, maxSuggestions }: UseSearchAutocompleteParams) => {
  const [matchedTerm, setMatchedTerm] = useState<string>('')
  const [suggestions, setSuggestions] = useState<ReadonlyArray<SearchOptionLinksObject>>([])

  const isInitialLoadReady = useSelector(getIsInitialLoadReady)
  const canLoadPopularSearches = isInitialLoadReady

  const getAutocompleteSuggestions = async (searchQuery) => {
    if (canLoadPopularSearches) {
      if (searchQuery.length < 1) {
        setSuggestions([])
        return
      }

      const autocompleteResponse = await searchService.fetchSearchProviderAutocomplete({
        query: searchQuery,
        shouldLowerCaseText: true,
        numResults: maxSuggestions,
      })

      if (autocompleteResponse.success) {
        setSuggestions(autocompleteResponse.payload.data.autocompleteSuggestions)
        setMatchedTerm(autocompleteResponse.payload.data.matchedTerm)
        return
      }

      setSuggestions([])
    }
  }

  return { matchedTerm, suggestions, getAutocompleteSuggestions, setSuggestions }
}

export default useSearchAutocomplete
